"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRuleV1 = void 0;
const isRuleV1 = (rule) => (typeof rule === 'string' && (rule === 'Namespace' || rule === 'Pass')) ||
    !('type' in rule);
exports.isRuleV1 = isRuleV1;
//# sourceMappingURL=rule.js.map